import React, {useState} from "react";
import {Divider, Form, Typography} from "antd";
import {StrategyParam} from "./StrategyParam";

export const StrategyEditor = ({setStrategy, strategy, vars, model, region}) => {
    const [render, setRender] = useState(0)
    const [form] = Form.useForm()

    const setStrategyAndRerender = (val) => {
        setStrategy(val)
        //setRender(render => render + 1)
        form.setFieldsValue(val)
        console.log('vl', val)
    }

    const generator = model.stepOption.find(item => item.value == model.generator && model.generator)

    //console.log('generator', (generator?.dataRegion || [])[region], generator.data[0] )
    let mx = 1

    if (generator) {
        const generatorRegion = (generator?.dataRegion || [])[region]
        if (generatorRegion) {
            mx = generatorRegion.data[0] / generator.data[0]
        }
    }
    //const mx = generator ? ( (((generator?.dataRegion || [])[region] || [] )[0] || 0) / generator.data[0]) : 1
    console.log('mx', mx)


    return <Form form={form} onValuesChange={(changedValues, allValues) => setStrategy(allValues)} initialValues={strategy} >
    <div>
        {
            model.buildTotalPrep &&
            <StrategyParam title={"Атезолизумаб всего, %"} prefix={'AZ'} strategy={strategy} primary
                           changeGlobal={['H2', 'H3', 'H4', 'H5']} mx={mx}
                           setStrategy={setStrategyAndRerender}/>
        }



        {vars.strategy.map(item =>
            <StrategyParam key={item.prefix} title={item.title} prefix={item.prefix}
                           strategy={strategy} mx={mx}/>)}

        {vars.mutation?.length > 0 && <>
            <Divider style={{margin: '12px 0'}}/>
            <Typography.Text type={"secondary"} style={{fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.4}}>
                Уточнения
            </Typography.Text>
            {vars.mutation.map(item =>
                <StrategyParam key={item.prefix} title={item.title} prefix={item.prefix}
                               strategy={strategy} one mx={mx}/>)}
        </>}
    </div>
</Form>}



export default StrategyEditor
